import React, { Component } from 'react';
import { Route, Switch, Redirect } from "react-router-dom";
import { Grid, Row, Col } from "react-bootstrap";
import Select from 'react-select';

import { CustomCard } from "../../components/Card/CustomCard";

import OptionContent1 from "./OptionContent1";
import OptionContent2 from "./OptionContent2";
import DatosEstadisticos from "./DatosEstadisticos";
/* import TEMPORAL from "./TEMPORAL"; */

class OpcionesAdmin extends Component {
    state = {
        valorActividad: { value: 'dias', label: 'Opciones de Fecha' },
    }

    Selecciona = (link) => {
        switch (link) {
            case "/preferencias_admin/dias":
                return({ value: 'dias', label: 'Opciones de Fecha' })
            case "/preferencias_admin/opciones":
                return({ value: 'opciones', label: 'Preferencias' })
            case "/preferencias_admin/estadisticas":
                return({ value: 'estadisticas', label: 'Datos Estadísticos' })
            default:
                return({ value: 'dias', label: 'Opciones de Fecha' })
        }
    }

    valorEstadosLabel = (link) => {
        switch (link) {
            case "/preferencias_admin/dias": return('Opciones de Fecha')
            case "/preferencias_admin/opciones": return('Preferencias')
            case "/preferencias_admin/estadisticas": return('Datos Estadísticos')
            default: return('Opciones de Fecha')
        }
    }

    valorActividad = (valorActividad) => {
        this.setState({
            valorActividad
        },() => {
            this.props.history.push(`/preferencias_admin/${this.state.valorActividad.value}`);
        });
    }

    contenido = () => {
        return (
            <Switch>
                <Route path="/preferencias_admin/dias" component={ () => <OptionContent1 /> } />
                <Route path="/preferencias_admin/opciones" component={ () => <OptionContent2 /> } />
                <Route path="/preferencias_admin/estadisticas" component={ () => <DatosEstadisticos /> } />
                <Redirect to = "/preferencias_admin/dias" />
            </Switch>
        )
    }

    render() {
        const Opciones = [
            { value: 'dias', label: 'Opciones de Fecha' },
            { value: 'opciones', label: 'Preferencias' },
            { value: 'estadisticas', label: 'Datos Estadísticos' },
        ];

        return (
            <div className="content">
                <Grid fluid>
                    <div className="custom-alert-info" style={{marginBottom:15, padding:5}}>
                        <Row>
                            <Col md={9}>
                                <div className="title" style={{fontSize:14, paddingTop: 10}}>
                                    Selecciona una opción
                                </div>
                            </Col>
                            <Col md={3}>
                                <Select
                                    isSearchable ={true}
                                    value={this.Selecciona(this.props.history.location.pathname)}
                                    onChange={this.valorActividad}
                                    options={Opciones}
                                />
                            </Col>
                        </Row>
                    </div>
                    <Row>
                        <Col md={12}>
                            <CustomCard
                                title={`${this.valorEstadosLabel(this.props.history.location.pathname)}`}
                                category=""
                                color="#a80012"
                                content={this.contenido()}
                            />
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}
 
export default OpcionesAdmin;


// WEBPACK FOOTER //
// ./src/views/Opciones/OpcionesAdmin.jsx